export class DialogPopupModel {
  id?: number;
  type: any;
  status?: boolean;
  modalData: any;
  projectId?: number;
  companyId?: number;
}
